(function() {
  'use strict';

  function wrapMultiLineLinks() {
    const links = document.querySelectorAll('.section-collection-featured-links .link--wave');
    
    links.forEach(link => {
      const span = link.querySelector('span');
      if (!span) return;
      
      const rects = span.getClientRects();
      
      if (rects.length <= 1) {
        span.removeAttribute('data-multi-line');
        return;
      }
      
      span.setAttribute('data-multi-line', 'true');
      
      const container = span.parentElement;
      const existingLines = container.querySelectorAll('.link--wave-line-bg');
      existingLines.forEach(el => el.remove());
      
      Array.from(rects).forEach(rect => {
        const lineBg = document.createElement('span');
        lineBg.className = 'link--wave-line-bg';
        lineBg.style.cssText = `
          position: absolute;
          left: ${rect.left - container.getBoundingClientRect().left}px;
          top: ${rect.top - container.getBoundingClientRect().top}px;
          width: ${rect.width}px;
          height: ${rect.height}px;
          pointer-events: none;
        `;
        container.appendChild(lineBg);
      });
    });
  }

  window.addEventListener('load', () => {
    setTimeout(wrapMultiLineLinks, 150);
  });

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      document.querySelectorAll('.section-collection-featured-links .link--wave-line-bg').forEach(el => el.remove());
      wrapMultiLineLinks();
    }, 300);
  });
})();
